<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
          class="no-redirect"
        >
          <!--  --- ${isPcMode ? "PC端" : "移动端"} -->
          {{ navPageBol ? `${rlProject_name}` : item.meta.title }}
        </span>

        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from "path-to-regexp";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      levelList: null,
    };
  },
  computed: {
    ...mapGetters(["rlProject_id", "rlProject_name", "isPcMode"]),
    navPageBol() {
      const hasDetection = this.$route.path.includes("inspectionLite");
      return hasDetection;
    },
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      const matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );

      // 添加“首页”项的逻辑---------------------
      // const first = matched[0];
      // if (!this.isDashboard(first)) {
      //   matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      // }

      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === "home".toLocaleLowerCase();
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  margin-left: 8px;
  .no-redirect,
  .moduleTitle {
    color: #262626;
    cursor: text;
    font-weight: 700;
  }
}
</style>
